import { createAction } from 'shared/utils';

export const RESIDENT_REFRESH = 'RESIDENT_REFRESH';
export const RESIDENT_GETS = createAction('RESIDENT_GETS');
export const RESIDENT_DELETE = createAction('RESIDENT_DELETE');
export const RESIDENT_IMPORT = createAction('RESIDENT_IMPORT');
export const RESIDENT_EXPORT = createAction('RESIDENT_EXPORT');
export const RESIDENT_CHANGE_STATUS = createAction('RESIDENT_CHANGE_STATUS');
